var $ = require("jquery");

$(function () {
    var $header = $("#header");

    // Nav Fixed
    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            $(".sp__banner").addClass("is-fixed");
        } else {
            $(".sp__banner").removeClass("is-fixed");
        }
    });

    // Nav Toggle Button
    $("#toggle").click(function () {
        $header.toggleClass("is-open");
        checkHeader();
    });

    $(".header__innerNav").click(function (e) {
        if (e.target === e.currentTarget) {
            $header.removeClass("is-open");
            checkHeader();
        }
    });

    function checkHeader() {
        if ($header.hasClass("is-open")) {
            $("body").css("overflow", "hidden");
        } else {
            $("body").css("overflow", "");
        }
    }
});
